import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails,
    CognitoUserAttribute
} from 'amazon-cognito-identity-js';
import {Config, CognitoIdentityCredentials} from 'aws-sdk';

/** @class */
export default class Cognito {
    static install = (Vue, options) => {
        Object.defineProperty(Vue.prototype, '$cognito', {
            get() {
                if (!this.$root._cognito) {
                    this.$root._cognito = new Cognito(options);
                }
                return this.$root._cognito;
            }
        });

        Vue.mixin({
            beforeCreate() {
                if (!this.$root._cognito) {
                    this.$root._cognito = new Cognito(options);
                }
            }
        });
    };

    /**
     * @constructor
     * @param config
     */
    constructor(config) {
        Config.region = config.COGNITO.REGION;
        Config.credentials = new CognitoIdentityCredentials({
            IdentityPoolId: config.COGNITO.IDENTITYPOOLID
        });
        this.userPool = new CognitoUserPool({
            UserPoolId: config.COGNITO.USERPOOLID,
            ClientId: config.COGNITO.USERPOOLCLIENTID
        });
        return this;
    }

    /**
     * username, passwordでサインアップ
     * username = emailとしてUserAttributeにも登録
     * @param username {String}
     * @param password {String}
     * @returns {Promise<any>}
     */
    signUp(username, password) {
        const dataEmail = {Name: 'email', Value: username};
        const attributeList = [];
        attributeList.push(new CognitoUserAttribute(dataEmail));
        return new Promise((resolve, reject) => {
            this.userPool.signUp(username, password, attributeList, null, (err, result) => {
                if (err) {
                    reject(err);
                } else {
                    resolve('');
                }
            });
        });
    }

    /**
     * 確認コードからユーザーを有効化する
     * @param username
     * @param confirmationCode
     * @returns {Promise<any>}
     */
    confirmation(username, confirmationCode) {
        const userData = {Username: username, Pool: this.userPool};
        const cognitoUser = new CognitoUser(userData);
        return new Promise((resolve, reject) => {
            cognitoUser.confirmRegistration(confirmationCode, true, (err, result) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(result);
                }
            });
        });
    }

    /**
     * username, passwordでログイン
     */
    login(username, password) {
        const userData = {Username: username, Pool: this.userPool};
        const cognitoUser = new CognitoUser(userData);
        const authenticationData = {Username: username, Password: password};
        const authenticationDetails = new AuthenticationDetails(authenticationData);
        return new Promise((resolve, reject) => {
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: (result) => {
                    resolve(result);
                },
                onFailure: (err) => {
                    reject(err.code);
                }
            });
        });
    }

    /**
     * ログアウト
     */
    logout() {
        this.getCurrentUser().signOut();
    }

    /**
     * Login中のUserを返却
     * @returns {CognitoUser}
     */
    getCurrentUser() {
        return this.userPool.getCurrentUser();
    }

    /**
     * ログインしているユーザーのAuthTokenを取得。
     */
    authToken() {
        const cognitoUser = this.getCurrentUser();
        return new Promise((resolve) => {
            if (cognitoUser === null) {
                resolve(null);
            }
            cognitoUser.getSession((err, session) => {
                if (err) {
                    resolve(null);
                } else {
                    if (!session.isValid()) {
                        resolve(null);
                    } else {
                        resolve(session.getIdToken().getJwtToken());
                    }
                }
            });
        });
    }

    static get ERROR_CODE() {
        return {
            NOT_AUTHORIZED: 'NotAuthorizedException',
            NOT_CONFIRMED: 'UserNotConfirmedException'
        };
    }
}



// WEBPACK FOOTER //
// ./src/custom_plugins/auth/cognito.js